module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4 elevation-0"
  }, [(!_vm.fatalError) ? _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(!_vm.submited) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Identificação do aluno")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Curso",
      "data-vv-as": "Curso",
      "data-vv-name": "exam.course",
      "errors": _vm.vErrors.collect('exam.course'),
      "required": "",
      "autocomplete": "",
      "prepend-icon": "class",
      "disabled": _vm.studentChecked,
      "readonly": _vm.readonly,
      "no-data-text": _vm.noDataText,
      "items": _vm.userCourses,
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      "change": function($event) {
        _vm.exam.type = ''
      }
    },
    model: {
      value: (_vm.exam.course),
      callback: function($$v) {
        _vm.$set(_vm.exam, "course", $$v)
      },
      expression: "exam.course"
    }
  }), _vm._v(" "), (!_vm.studentChecked) ? _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Aluno",
      "data-vv-as": "Aluno",
      "data-vv-name": "exam.student",
      "errors": _vm.vErrors.collect('exam.student'),
      "required": "",
      "autocomplete": "",
      "prepend-icon": "person",
      "disabled": !_vm.exam.course,
      "loading": _vm.studentLoading,
      "no-data-text": _vm.noDataText,
      "items": _vm.students,
      "search-input": _vm.searchStudentVal,
      "item-text": "name_and_id",
      "item-value": "id"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchStudentVal = $event
      },
      "update:search-input": function($event) {
        _vm.searchStudentVal = $event
      }
    },
    model: {
      value: (_vm.exam.student),
      callback: function($$v) {
        _vm.$set(_vm.exam, "student", $$v)
      },
      expression: "exam.student"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.studentChecked) ? _c('v-text-field', {
    attrs: {
      "label": "Aluno",
      "readonly": "",
      "prepend-icon": "subject"
    },
    model: {
      value: (_vm.exam.studentName),
      callback: function($$v) {
        _vm.$set(_vm.exam, "studentName", $$v)
      },
      expression: "exam.studentName"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Informações do trabalho")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Tipo",
      "data-vv-as": "Tipo",
      "data-vv-name": "exam.type",
      "errors": _vm.vErrors.collect('exam.type'),
      "required": "",
      "prepend-icon": "create",
      "disabled": _vm.studentChecked,
      "readonly": _vm.readonly,
      "no-data-text": _vm.noDataText,
      "items": _vm.courseTypes,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.exam.type),
      callback: function($$v) {
        _vm.$set(_vm.exam, "type", $$v)
      },
      expression: "exam.type"
    }
  }), _vm._v(" "), (_vm.studentChecked) ? [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Título",
      "data-vv-as": "Título",
      "data-vv-name": "exam.title",
      "errors": _vm.vErrors.collect('exam.title'),
      "required": "",
      "prepend-icon": "title",
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.exam.title),
      callback: function($$v) {
        _vm.$set(_vm.exam, "title", $$v)
      },
      expression: "exam.title"
    }
  })] : _vm._e()], 2)], 1), _vm._v(" "), (_vm.studentChecked) ? [_c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Informações da sessão")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": true,
      "transition": "v-scale-transition",
      "offset-y": "",
      "nudge-left": 40
    },
    model: {
      value: (_vm.menuReleaseDate),
      callback: function($$v) {
        _vm.menuReleaseDate = $$v
      },
      expression: "menuReleaseDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Data de divulgação",
      "data-vv-as": "Data de divulgação",
      "data-vv-name": "exam.release_date",
      "errors": _vm.vErrors.collect('exam.release_date'),
      "readonly": "",
      "prepend-icon": "date_range"
    },
    slot: "activator",
    model: {
      value: (_vm.formattedReleaseDate),
      callback: function($$v) {
        _vm.formattedReleaseDate = $$v
      },
      expression: "formattedReleaseDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "locale": "pt-BR"
    },
    model: {
      value: (_vm.exam.release_date),
      callback: function($$v) {
        _vm.$set(_vm.exam, "release_date", $$v)
      },
      expression: "exam.release_date"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": true,
      "transition": "v-scale-transition",
      "offset-y": "",
      "nudge-left": 40,
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.menuDate),
      callback: function($$v) {
        _vm.menuDate = $$v
      },
      expression: "menuDate"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "slot": "activator",
      "label": "Data",
      "data-vv-as": "Data",
      "data-vv-name": "exam.date",
      "errors": _vm.vErrors.collect('exam.date'),
      "required": "",
      "readonly": "",
      "prepend-icon": "date_range"
    },
    slot: "activator",
    model: {
      value: (_vm.formattedDate),
      callback: function($$v) {
        _vm.formattedDate = $$v
      },
      expression: "formattedDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "locale": "pt-BR"
    },
    model: {
      value: (_vm.exam.date),
      callback: function($$v) {
        _vm.$set(_vm.exam, "date", $$v)
      },
      expression: "exam.date"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "v-scale-transition",
      "offset-y": "",
      "nudge-left": 40,
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.menuTime),
      callback: function($$v) {
        _vm.menuTime = $$v
      },
      expression: "menuTime"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "slot": "activator",
      "label": "Hora",
      "data-vv-as": "Hora",
      "data-vv-name": "exam.hour",
      "errors": _vm.vErrors.collect('exam.hour'),
      "required": "",
      "readonly": "",
      "prepend-icon": "access_time"
    },
    slot: "activator",
    model: {
      value: (_vm.exam.hour),
      callback: function($$v) {
        _vm.$set(_vm.exam, "hour", $$v)
      },
      expression: "exam.hour"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    model: {
      value: (_vm.exam.hour),
      callback: function($$v) {
        _vm.$set(_vm.exam, "hour", $$v)
      },
      expression: "exam.hour"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Local",
      "data-vv-as": "Local",
      "data-vv-name": "exam.place",
      "errors": _vm.vErrors.collect('exam.place'),
      "required": "",
      "prepend-icon": "edit_location",
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.exam.place),
      callback: function($$v) {
        _vm.$set(_vm.exam, "place", $$v)
      },
      expression: "exam.place"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Vagas",
      "data-vv-as": "Vagas",
      "data-vv-name": "exam.vacancies",
      "errors": _vm.vErrors.collect('exam.vacancies'),
      "prepend-icon": "persons"
    },
    model: {
      value: (_vm.exam.vacancies),
      callback: function($$v) {
        _vm.$set(_vm.exam, "vacancies", $$v)
      },
      expression: "exam.vacancies"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Composição da banca")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Presidente",
      "data-vv-as": "Presidente",
      "data-vv-name": "exam.chair",
      "errors": _vm.vErrors.collect('exam.chair'),
      "required": "",
      "autocomplete": "",
      "prepend-icon": "person",
      "readonly": _vm.readonly,
      "no-data-text": _vm.noDataText,
      "items": _vm.teachersComputed,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.exam.chair),
      callback: function($$v) {
        _vm.$set(_vm.exam, "chair", $$v)
      },
      expression: "exam.chair"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.chairIsExaminer),
      callback: function($$v) {
        _vm.chairIsExaminer = $$v
      },
      expression: "chairIsExaminer"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("O presidente também é examinador")])]), _vm._v(" "), _vm._l((_vm.exam.examiners), function(examiner, idx) {
    return _c('v-layout', {
      key: 'examiner-' + idx,
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm11": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": 'Examinador ' + (idx + 1),
        "no-data-text": _vm.noDataText,
        "prepend-icon": "person",
        "rules": [function (v) { return !!v || 'O examinador ' + (idx + 1) + ' precisa ser informado'; }],
        "required": "",
        "autocomplete": "",
        "readonly": _vm.readonly,
        "items": _vm.teachersComputed,
        "item-text": "name",
        "item-value": "id"
      },
      model: {
        value: (_vm.exam.examiners[idx]),
        callback: function($$v) {
          _vm.$set(_vm.exam.examiners, idx, $$v)
        },
        expression: "exam.examiners[idx]"
      }
    })], 1), _vm._v(" "), (!_vm.readonly) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm1": ""
      }
    }, [_c('v-btn', {
      staticClass: "red",
      attrs: {
        "fab": "",
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exam.examiners.splice(idx, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("remove")])], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), (!_vm.readonly) ? _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-btn', {
    staticClass: "green",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.exam.examiners.push('')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Adicionar examinador\n                  ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.exam.substitutes), function(substitute, idx) {
    return _c('v-layout', {
      key: 'substitute-' + idx,
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm11": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": 'Suplente ' + (idx + 1),
        "data-vv-as": 'Suplente ' + (idx + 1),
        "data-vv-name": "exam.substitutes[idx]",
        "prepend-icon": "person",
        "rules": [function (v) { return !!v || 'O suplente ' + (idx + 1) + ' precisa ser informado'; }],
        "required": "",
        "autocomplete": "",
        "readonly": _vm.readonly,
        "no-data-text": _vm.noDataText,
        "items": _vm.teachers,
        "item-text": "name",
        "item-value": "id"
      },
      model: {
        value: (_vm.exam.substitutes[idx]),
        callback: function($$v) {
          _vm.$set(_vm.exam.substitutes, idx, $$v)
        },
        expression: "exam.substitutes[idx]"
      }
    })], 1), _vm._v(" "), (!_vm.readonly) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm1": ""
      }
    }, [_c('v-btn', {
      staticClass: "red",
      attrs: {
        "fab": "",
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.exam.substitutes.splice(idx, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("remove")])], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), (!_vm.readonly) ? _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-btn', {
    staticClass: "green",
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.exam.substitutes.push('')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Adicionar suplente\n                  ")], 1)], 1)], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.exam.id > 0 && _vm.exam.perms['viewEvaluations']) ? [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Avaliação dos examinadores")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('exam-evaluations', {
    attrs: {
      "exam-id": _vm.exam.id,
      "show-header": false,
      "refresh-interval": _vm.isFinished ? null : 5
    },
    on: {
      "updateNotaMedia": function($event) {
        return _vm.notaMediaUpdate($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), (_vm.hasExternalEvaluation) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Nota Externa")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nota",
      "id": "externalNote",
      "data-nvalue": _vm.exam.externalNote,
      "prepend-icon": "star",
      "data-vv-as": "Nota",
      "type": "number",
      "step": "0.01",
      "max": "10",
      "required": ""
    },
    model: {
      value: (_vm.externalNote),
      callback: function($$v) {
        _vm.externalNote = $$v
      },
      expression: "externalNote"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-subheader', [_vm._v("Resultado da banca")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:10'),
      expression: "'required|min_value:0|max_value:10'"
    }],
    attrs: {
      "label": "Nota",
      "data-vv-as": "Nota",
      "data-vv-name": "exam.finalScore",
      "errors": _vm.vErrors.collect('exam.finalScore'),
      "type": "number",
      "step": "0.01",
      "required": "",
      "prepend-icon": "star",
      "readonly": "readonly"
    },
    model: {
      value: (_vm.exam.finalScore),
      callback: function($$v) {
        _vm.$set(_vm.exam, "finalScore", $$v)
      },
      expression: "exam.finalScore"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.exam.finalScore >= 9 ? 'Recomendações' : 'Justificativa',
      "data-vv-as": "Recomendações",
      "data-vv-name": "exam.notes",
      "errors": _vm.vErrors.collect('exam.notes'),
      "prepend-icon": "rate_review",
      "multi-line": "",
      "auto-grow": "",
      "rows": "3",
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.exam.notes),
      callback: function($$v) {
        _vm.$set(_vm.exam, "notes", $$v)
      },
      expression: "exam.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(!_vm.readonly) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "info": "",
      "value": _vm.vErrors.any()
    }
  }, [_vm._v("\n                Algum campo não foi preenchido corretamente. Revise o preenchimento dos dados para continuar.\n              ")]), _vm._v(" "), (_vm.submitErrors.length) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": _vm.submitErrors
    }
  }, [_vm._v("\n                Ocorreram os seguintes erros na submissão do formulário:\n                "), _c('ul', _vm._l((_vm.submitErrors), function(error, e_idx) {
    return _c('li', {
      key: e_idx
    }, [_vm._v(_vm._s(error))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.exam.situation !== 'Finalizada') ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "success",
      "type": "buttom",
      "disabled": _vm.vErrors.any()
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("done")]), _vm._v(" Finalizar\n              ")], 1) : _c('div', {
    staticClass: "show-status"
  }, [_vm._v("\n                Status da banca: " + _vm._s(_vm.exam.situation) + "\n              ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.readonly) ? _c('v-flex', [_c('v-alert', {
    attrs: {
      "info": "",
      "value": true
    }
  }, [_vm._v("\n                  Você não pode alterar os dados desta banca.\n              ")])], 1) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.submited) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "green darken-1"
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Registro confirmado")])]), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "height": "75px"
    }
  }, [_c('v-icon', {
    staticClass: "mr-4",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("done")]), _vm._v("\n                O registro da banca foi " + _vm._s(_vm.edit ? 'atualizado' : 'registrado') + " com sucesso no sistema sob o\n                  "), _c('v-chip', {
    staticClass: "green darken-1 white--text"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'examDetail',
        params: {
          id: _vm.exam.id
        }
      }
    }
  }, [_vm._v("n.º " + _vm._s(_vm.exam.id))])], 1), _vm._v(".\n              ")], 1), _vm._v(" "), _c('v-card-text', [_c('exam-documents', {
    attrs: {
      "exam-id": _vm.exam.id,
      "teachers": _vm.allTeachers
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "orange darken-3",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.attendanceDialog = true
      }
    }
  }, [_vm._v("\n                  Registrar e certificar presença dos participantes\n                ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green darken-1",
    attrs: {
      "dark": "",
      "to": "/bancas/registrar"
    }
  }, [_vm._v("\n                  Registrar outra banca\n                ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fatalError) ? _c('v-alert', {
    attrs: {
      "value": true,
      "error": ""
    }
  }, [_vm._v("Erro ao carregar dados. Certifique-se de que a banca " + _vm._s(_vm.id) + " existe e você tem acesso a ela.")]) : _vm._e(), _vm._v(" "), _c('fullscreen-spinner'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.attendanceDialog),
      callback: function($$v) {
        _vm.attendanceDialog = $$v
      },
      expression: "attendanceDialog"
    }
  }, [_c('exam-attendance', {
    attrs: {
      "exam-id": _vm.exam.id
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.attendanceDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe8d931"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamDetail.vue
// module id = 244
// module chunks = 0